import { Box, styled } from '@mui/material';
const getGap = (size = 'large') => {
    switch (size) {
        case 'large':
            return 2;
        case 'medium':
            return 1;
    }
    return 0.5;
};
const getBorderHeight = (size = 'large') => {
    switch (size) {
        case 'large':
            return '8rem';
        case 'medium':
            return '2.3rem';
        case 'small':
            return '2em';
    }
    return '1.7rem';
};
const getHeight = (variant, size = 'large') => {
    switch (variant) {
        case 'inner':
            return getInnerHeight(size);
        case 'outer':
            return getOuterHeight(size);
    }
    return getIdleHeight(size);
};
const getIdleHeight = (size = 'large') => {
    switch (size) {
        case 'large':
            return '1rem';
        case 'medium':
            return '0.3rem';
    }
    return '0.3rem';
};
const getInnerHeight = (size = 'large') => {
    switch (size) {
        case 'large':
            return '4.5rem';
        case 'medium':
            return '1rem';
    }
    return '0.7rem';
};
const getOuterHeight = (size = 'large') => {
    switch (size) {
        case 'large':
            return '6.5rem';
        case 'medium':
            return '1.5rem';
    }
    return '1rem';
};
export const IndicatorContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'backgroundColor' && prop !== 'size',
})(({ theme, backgroundColor, size = 'large' }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(getGap(size)),
    backgroundColor: backgroundColor ?? theme.palette.primary.main,
    borderRadius: theme.spacing(20),
    minHeight: getBorderHeight(size),
    minWidth: getBorderHeight(size),
}));
export const Indicator = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'size' && prop !== 'variant',
})(({ theme, variant, size = 'large' }) => ({
    width: getIdleHeight(size),
    height: getHeight(variant, size),
    borderRadius: theme.spacing(5),
    backgroundColor: theme.palette.common.white,
}));
//# sourceMappingURL=data:application/json;base64,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